import PropTypes from 'prop-types';
import GS from '../grafsync/grafsync';
import { makeCancelable } from './utils/utils';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const styles = {
  projectWarning: {
    color: '#FF6F00',
    marginTop: '6px',
    marginBottom: '12px'
  }
};

class CheckIfUsedAsAssociated extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isUsed: false
    };
    this.cancellable = null;
  }

  doCheck(payload) {
    this.cancellable = makeCancelable(GS.checkForInbound(payload));
    return this.cancellable;
  }

  componentDidMount() {
    this.doCheck({
      value: this.props.id,
      predicate: "https://grafsync.graphifi.com/schema/vm/associatedProject"
    })
      .promise
      .then((isUsed) => {
        if (this.cancellable && this.cancellable.isCancelled()) return;
        if (isUsed) this.setState({ isUsed: true });
      })
      .catch(() => {
        if (this.cancellable && !this.cancellable.isCancelled()) return;
      });
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  render() {

    const { classes } = this.props;

    if (!this.state.isUsed) return null;

    return (
      <div className={classes.projectWarning}>
        <Typography variant="body2">This ontology project is used by one or more taxonomy projects.</Typography>
        <Typography variant="body2">Changing it could have a major impact on those projects.</Typography>
      </div>
    );

  }
}

CheckIfUsedAsAssociated.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(CheckIfUsedAsAssociated);